/* AquaRuby Workspace (Android staff app) - the web app's side of the native bridge. No dependencies, no Capacitor code.

   Inside the Android app, www/native-bridge.js (built in mobile/staff-app/bridge/, never part of the website) runs
   before the web app and sets window.AquaRubyNative. On the website it does not exist: isNativeApp() is false and
   every helper returns the website's own value, so the website behaves exactly as before.
   Contract: mobile/staff-app/bridge/core.mjs (version, appId, flavor, apiBase, ready, onPushTap, onForegroundPush,
   onBackButton, onResume, pushPermission, requestPushPermission, registerAfterSignIn, unregisterBeforeLogout,
   saveAndShare, exitApp, hideSplash, firebasePresent). */

/** The bridge object inside the Android app, otherwise null. Never throws. */
export function nativeApp(win = typeof window !== 'undefined' ? window : undefined) {
  try {
    const n = win && win.AquaRubyNative;
    return n && typeof n === 'object' ? n : null;
  } catch {
    return null;
  }
}

/** True only inside the Android app. */
export function isNativeApp(win) {
  return !!nativeApp(win);
}

/** The server address to use. Website: exactly the value it had before. Android app: the app's server (by app id),
    or null while the app is still starting. */
export function backendBase(webValue) {
  const n = nativeApp();
  return n ? (n.apiBase || null) : webValue;
}

/** Calls fn(apiBase) inside the Android app once the server is known (at once if already known). Never on the website. */
export function whenNativeBackend(fn) {
  const n = nativeApp();
  if (!n) return;
  if (n.apiBase) { fn(n.apiBase); return; }
  Promise.resolve(n.ready).then((r) => { if (r && r.ok && n.apiBase) fn(n.apiBase); }).catch(() => {});
}

/* Android app: "refresh the notifications inbox" (app back on screen, a push arrived). On the website nobody
   sends it and onInboxRefresh() adds no listener at all. */
export const INBOX_REFRESH_EVENT = 'aquaruby:inbox-refresh';

export function emitInboxRefresh() {
  try { window.dispatchEvent(new Event(INBOX_REFRESH_EVENT)); } catch { /* ignore */ }
}

/** Calls fn when the app asks for a refresh; returns the function that stops listening. */
export function onInboxRefresh(fn) {
  if (!isNativeApp()) return () => {};
  const h = () => fn();
  window.addEventListener(INBOX_REFRESH_EVENT, h);
  return () => window.removeEventListener(INBOX_REFRESH_EVENT, h);
}
